export default "__VITE_ASSET__Qyk8slBi__"